/**
 * Transliteration Service
 * Converts Hebrew text to English/Latin characters
 * Used for searching in APIs that don't support Hebrew well (like Photon)
 */

// Mapping of common Hebrew cities/places to English names
const commonPlacesMapping = {
  'דובאי': 'Dubai',
  'תל אביב': 'Tel Aviv',
  'תל-אביב': 'Tel Aviv',
  'ירושלים': 'Jerusalem',
  'חיפה': 'Haifa',
  'אילת': 'Eilat',
  'פריז': 'Paris',
  'ליון': 'Lyon',
  'מרסיי': 'Marseille',
  'ניס': 'Nice',
  'טולוז': 'Toulouse',
  'בורדו': 'Bordeaux',
  'שטרסבורג': 'Strasbourg',
  'ליל': 'Lille',
  'לונדון': 'London',
  'בירמינגהם': 'Birmingham',
  'מנצ\'סטר': 'Manchester',
  'ליברפול': 'Liverpool',
  'אדינבורו': 'Edinburgh',
  'גלאזגו': 'Glasgow',
  'בריסטול': 'Bristol',
  'לידס': 'Leeds',
  'ניוקאסל': 'Newcastle',
  'נוטינגהאם': 'Nottingham',
  'לסטר': 'Leicester',
  'קובנטרי': 'Coventry',
  'ברייטון': 'Brighton',
  'בורנמות': 'Bournemouth',
  'פלימות': 'Plymouth',
  'נוריץ': 'Norwich',
  'ניו יורק': 'New York',
  'לוס אנג\'לס': 'Los Angeles',
  'שיקגו': 'Chicago',
  'יוסטון': 'Houston',
  'פיניקס': 'Phoenix',
  'פילדלפיה': 'Philadelphia',
  'סן אנטוניו': 'San Antonio',
  'סן דייגו': 'San Diego',
  'דאלאס': 'Dallas',
  'סן חוזה': 'San Jose',
  'אוסטין': 'Austin',
  'ג\'קסונוויל': 'Jacksonville',
  'פורט וורת': 'Fort Worth',
  'קולומבוס': 'Columbus',
  'שארלוט': 'Charlotte',
  'סן פרנסיסקו': 'San Francisco',
  'אינדיאנפוליס': 'Indianapolis',
  'סיאטל': 'Seattle',
  'דנוור': 'Denver',
  'בוסטון': 'Boston',
  'אלאטה': 'El Paso',
  'דטרויט': 'Detroit',
  'נאשוויל': 'Nashville',
  'פורטלנד': 'Portland',
  'אוקלהומה סיטי': 'Oklahoma City',
  'לאס וגאס': 'Las Vegas',
  'ממפיס': 'Memphis',
  'לואיוויל': 'Louisville',
  'בולטימור': 'Baltimore',
  'מילווקי': 'Milwaukee',
  'אלבקרקי': 'Albuquerque',
  'טוסון': 'Tucson',
  'פריסקו': 'Fresno',
  'סקרמנטו': 'Sacramento',
  'קנזס סיטי': 'Kansas City',
  'מסה': 'Mesa',
  'אטלנטה': 'Atlanta',
  'קולורדו ספרינגס': 'Colorado Springs',
  'ראלי': 'Raleigh',
  'אומהה': 'Omaha',
  'מיאמי': 'Miami',
  'אוקלנד קליפורניה': 'Oakland',
  'מיניאפוליס': 'Minneapolis',
  'טולסה': 'Tulsa',
  'קליבלנד': 'Cleveland',
  'ויצ\'יטה': 'Wichita',
  'ארלינגטון': 'Arlington',
  'רומא': 'Rome',
  'מדריד': 'Madrid',
  'ברצלונה': 'Barcelona',
  'ולנסיה': 'Valencia',
  'סביליה': 'Seville',
  'בילבאו': 'Bilbao',
  'גרנדה': 'Granada',
  'קורדובה': 'Cordoba',
  'מאלגה': 'Malaga',
  'אמסטרדם': 'Amsterdam',
  'רוטרדם': 'Rotterdam',
  'האג': 'The Hague',
  'אוטרכט': 'Utrecht',
  'ברלין': 'Berlin',
  'מינכן': 'Munich',
  'המבורג': 'Hamburg',
  'קלן': 'Cologne',
  'פרנקפורט': 'Frankfurt',
  'שטוטגרט': 'Stuttgart',
  'דורטמונד': 'Dortmund',
  'דיסלדורף': 'Düsseldorf',
  'לייפציג': 'Leipzig',
  'וינה': 'Vienna',
  'אתונה': 'Athens',
  'תסלוניקי': 'Thessaloniki',
  'פטרס': 'Patras',
  'הרקליון': 'Heraklion',
  'רודוס': 'Rhodes',
  'מיקונוס': 'Mykonos',
  'סנטוריני': 'Santorini',
  'קורפו': 'Corfu',
  'ליסבון': 'Lisbon',
  'פורטו': 'Porto',
  'קוימברה': 'Coimbra',
  'בראגה': 'Braga',
  'פארו': 'Faro',
  'אווירו': 'Aveiro',
  'מילאנו': 'Milan',
  'נאפולי': 'Naples',
  'טורינו': 'Turin',
  'פלרמו': 'Palermo',
  'גנואה': 'Genoa',
  'בולוניה': 'Bologna',
  'ונציה': 'Venice',
  'פירנצה': 'Florence',
  'ברי': 'Bari',
  'קטניה': 'Catania',
  'מוסקבה': 'Moscow',
  'סנט פטרסבורג': 'Saint Petersburg',
  'נובוסיבירסק': 'Novosibirsk',
  'יקאטרינבורג': 'Yekaterinburg',
  'איסטנבול': 'Istanbul',
  'אנקרה': 'Ankara',
  'איזמיר': 'Izmir',
  'אנטליה': 'Antalya',
  'בודפשט': 'Budapest',
  'דברצן': 'Debrecen',
  'סגד': 'Szeged',
  'בוקרשט': 'Bucharest',
  'קלוז': 'Cluj-Napoca',
  'טימישוארה': 'Timișoara',
  'סופיה': 'Sofia',
  'פלובדיב': 'Plovdiv',
  'ורשה': 'Warsaw',
  'קרקוב': 'Krakow',
  'גדנסק': 'Gdansk',
  'ורוצלב': 'Wroclaw',
  'פוזנן': 'Poznan',
  'לודז': 'Łódź',
  'קטוביץ': 'Katowice',
  'לובלין': 'Lublin',
  'ביאליסטוק': 'Białystok',
  'גדיניה': 'Gdynia',
  'זאקופנה': 'Zakopane',
  'פראג': 'Prague',
  'ברנו': 'Brno',
  'אוסטרבה': 'Ostrava',
  'ברטיסלאבה': 'Bratislava',
  'קושיצה': 'Košice',
  'לובליאנה': 'Ljubljana',
  'זאגרב': 'Zagreb',
  'ספליט': 'Split',
  'דוברובניק': 'Dubrovnik',
  'בלגרד': 'Belgrade',
  'נובי סאד': 'Novi Sad',
  'סקופיה': 'Skopje',
  'סרייבו': 'Sarajevo',
  'קהיר': 'Cairo',
  'מרוקו': 'Morocco',
  'תוניס': 'Tunis',
  'שארם א-שייח': 'Sharm el-Sheikh',
  'שארם': 'Sharm el-Sheikh',
  'טורקיה': 'Turkey',
  'יוון': 'Greece',
  'קפריסין': 'Cyprus',
  'מצרים': 'Egypt',
  'תאילנד': 'Thailand',
  'בנגקוק': 'Bangkok',
  'בנקוק': 'Bangkok',
  'בנגקוק תאילנד': 'Bangkok Thailand',
  'בנקוק תאילנד': 'Bangkok Thailand',
  'צ\'יאנג מאי': 'Chiang Mai',
  'פוקט': 'Phuket',
  'פאטאיה': 'Pattaya',
  'קראבי': 'Krabi',
  'סין': 'China',
  'בייג\'ין': 'Beijing',
  'שנחאי': 'Shanghai',
  'גואנגג\'ואו': 'Guangzhou',
  'שנזן': 'Shenzhen',
  'צ\'נגדו': 'Chengdu',
  'נאנג\'ינג': 'Nanjing',
  'ווהאן': 'Wuhan',
  'שיאן': 'Xi\'an',
  'האנגג\'ואו': 'Hangzhou',
  'טיאנג\'ין': 'Tianjin',
  'צ\'ונגצ\'ינג': 'Chongqing',
  'דאליאן': 'Dalian',
  'צ\'ינגדאו': 'Qingdao',
  'טוקיו': 'Tokyo',
  'אוסקה': 'Osaka',
  'יוקוהמה': 'Yokohama',
  'קיוטו': 'Kyoto',
  'נגויה': 'Nagoya',
  'סאפורו': 'Sapporo',
  'פוקואוקה': 'Fukuoka',
  'הירושימה': 'Hiroshima',
  'סנדאי': 'Sendai',
  'סיאול': 'Seoul',
  'בוסאן': 'Busan',
  'אינצ\'ון': 'Incheon',
  'דאגו': 'Daegu',
  'גוואנגג\'ו': 'Gwangju',
  'סינגפור': 'Singapore',
  'הונג קונג': 'Hong Kong',
  'מקאו': 'Macau',
  'דלהי': 'Delhi',
  'מומבאי': 'Mumbai',
  'בנגלור': 'Bangalore',
  'היידראבאד': 'Hyderabad',
  'אחמדאבאד': 'Ahmedabad',
  'צ\'נאי': 'Chennai',
  'קולקטה': 'Kolkata',
  'סוראט': 'Surat',
  'פונה': 'Pune',
  'ג\'איפור': 'Jaipur',
  'לאקנאו': 'Lucknow',
  'קאנפור': 'Kanpur',
  'נגפור': 'Nagpur',
  'אינדור': 'Indore',
  'תאנה': 'Thane',
  'בופאל': 'Bhopal',
  'ויזאג': 'Visakhapatnam',
  'פימפרי': 'Pimpri-Chinchwad',
  'פטנה': 'Patna',
  'ואדודרה': 'Vadodara',
  'גאזיאבאד': 'Ghaziabad',
  'לודיאנה': 'Ludhiana',
  'אגרה': 'Agra',
  'נשיק': 'Nashik',
  'פארידאבאד': 'Faridabad',
  'מהרטה': 'Meerut',
  'ראג\'קוט': 'Rajkot',
  'וואראנסי': 'Varanasi',
  'סרינגאר': 'Srinagar',
  'אמריטסר': 'Amritsar',
  'אלאבאד': 'Allahabad',
  'ראנצ\'י': 'Ranchi',
  'גוואליאר': 'Gwalior',
  'ג\'ודפור': 'Jodhpur',
  'ראג\'פור': 'Raipur',
  'צ\'נדיגאר': 'Chandigarh',
  'גוואהאטי': 'Guwahati',
  'סולאפור': 'Solapur',
  'הובלי': 'Hubli',
  'מייסור': 'Mysore',
  'מנגלור': 'Mangalore',
  'קוצ\'י': 'Kochi',
  'קוזיקוד': 'Kozhikode',
  'טריוונדרום': 'Thiruvananthapuram',
  'טריצ\'י': 'Tiruchirappalli',
  'מדוראי': 'Madurai',
  'קוימבטור': 'Coimbatore',
  'סלאם': 'Salem',
  'ויראצ\'יפלאם': 'Vellore',
  'אודאיפור': 'Udaipur',
  'ביקנר': 'Bikaner',
  'ג\'איסלמר': 'Jaisalmer',
  'אוגאין': 'Ujjain',
  'גוואליור': 'Gwalior',
  'ג\'הנסי': 'Jhansi',
  'דלהי החדשה': 'New Delhi',
  'גורוגאון': 'Gurgaon',
  'נוידה': 'Noida',
  'גריטר נוידה': 'Greater Noida',
  'אבו דאבי': 'Abu Dhabi',
  'דוחה': 'Doha',
  'ריאד': 'Riyadh',
  'ג\'דה': 'Jeddah',
  'מכה': 'Mecca',
  'מדינה': 'Medina',
  // Capital cities and major cities with airports
  'וושינגטון': 'Washington',
  'וושינגטון די.סי.': 'Washington DC',
  'בריסל': 'Brussels',
  'ברן': 'Bern',
  'סטוקהולם': 'Stockholm',
  'אוסלו': 'Oslo',
  'קופנהגן': 'Copenhagen',
  'הלסינקי': 'Helsinki',
  'לוקסמבורג': 'Luxembourg',
  'דבלין': 'Dublin',
  'רייקיאוויק': 'Reykjavik',
  'ולטה': 'Valletta',
  'ניקוסיה': 'Nicosia',
  'קייב': 'Kyiv',
  'מינסק': 'Minsk',
  'וילנה': 'Vilnius',
  'ריגה': 'Riga',
  'טאלין': 'Tallinn',
  'טביליסי': 'Tbilisi',
  'ירוואן': 'Yerevan',
  'באקו': 'Baku',
  'אסטנה': 'Astana',
  'נור סולטן': 'Nur-Sultan',
  'אלמטי': 'Almaty',
  'טשקנט': 'Tashkent',
  'אשגבאט': 'Ashgabat',
  'בישקק': 'Bishkek',
  'דושנבה': 'Dushanbe',
  'קאבול': 'Kabul',
  'איסאבאד': 'Islamabad',
  'דאקה': 'Dhaka',
  'קולומבו': 'Colombo',
  'קטמנדו': 'Kathmandu',
  'טהימפהו': 'Thimphu',
  'נייפידאו': 'Naypyidaw',
  'יאנגון': 'Yangon',
  'ראנגון': 'Rangoon',
  'ויינטיאן': 'Vientiane',
  'פנום פן': 'Phnom Penh',
  'האנוי': 'Hanoi',
  'הו צ\'י מין סיטי': 'Ho Chi Minh City',
  'סייגון': 'Saigon',
  'קואלה לומפור': 'Kuala Lumpur',
  'ג\'קרטה': 'Jakarta',
  'בנדר סרי בגוואן': 'Bandar Seri Begawan',
  'מנילה': 'Manila',
  'טאיפיי': 'Taipei',
  'אולן בטור': 'Ulaanbaatar',
  'פיונגיאנג': 'Pyongyang',
  'טהראן': 'Tehran',
  'בגדאד': 'Baghdad',
  'דמשק': 'Damascus',
  'ביירות': 'Beirut',
  'עמאן': 'Amman',
  'רמאללה': 'Ramallah',
  'כווית סיטי': 'Kuwait City',
  'מנאמה': 'Manama',
  'מסקט': 'Muscat',
  'צנעא': 'Sana\'a',
  'חרטום': 'Khartoum',
  'ג\'ובה': 'Juba',
  'אדיס אבבה': 'Addis Ababa',
  'אסמרה': 'Asmara',
  'מוגדישו': 'Mogadishu',
  'ניירובי': 'Nairobi',
  'דודומה': 'Dodoma',
  'דאר א-סלאם': 'Dar es Salaam',
  'קמפלה': 'Kampala',
  'קיגאלי': 'Kigali',
  'בוג\'ומבורה': 'Bujumbura',
  'מפוטו': 'Maputo',
  'אנטננריבו': 'Antananarivo',
  'פורט לואי': 'Port Louis',
  'ויקטוריה': 'Victoria',
  'מורוני': 'Moroni',
  'נואקשוט': 'Nouakchott',
  'במאקו': 'Bamako',
  'ואגאדוגו': 'Ouagadougou',
  'ניאמיי': 'Niamey',
  'נג\'מנה': 'N\'Djamena',
  'יאונדה': 'Yaounde',
  'דואלה': 'Douala',
  'ליברוויל': 'Libreville',
  'ברזוויל': 'Brazzaville',
  'קינשאסה': 'Kinshasa',
  'בנגואי': 'Bangui',
  'מלאבו': 'Malabo',
  'סאו טומה': 'Sao Tome',
  'קונאקרי': 'Conakry',
  'ביסאו': 'Bissau',
  'בנג\'ול': 'Banjul',
  'דקר': 'Dakar',
  'אלג\'יר': 'Algiers',
  'אוראן': 'Oran',
  'טריפולי': 'Tripoli',
  'רבאט': 'Rabat',
  'קזבלנקה': 'Casablanca',
  'קנברה': 'Canberra',
  'סידני': 'Sydney',
  'מלבורן': 'Melbourne',
  'בריסביין': 'Brisbane',
  'ולינגטון': 'Wellington',
  'אוקלנד': 'Auckland',
  'סובה': 'Suva',
  'פורט מורסבי': 'Port Moresby',
  'הוניארה': 'Honiara',
  'פורט וילה': 'Port Vila',
  'נומאה': 'Noumea',
  'פפאטה': 'Papeete',
  'אפיה': 'Apia',
  'נוקואלופה': 'Nuku\'alofa',
  'טאראווה': 'Tarawa',
  'פונאפוטי': 'Funafuti',
  'יארן': 'Yaren',
  'נגרולמוד': 'Ngerulmud',
  'פליקיר': 'Palikir',
  'מג\'ורו': 'Majuro',
  'אוטווה': 'Ottawa',
  'טורונטו': 'Toronto',
  'ונקובר': 'Vancouver',
  'מונטריאול': 'Montreal',
  'מקסיקו סיטי': 'Mexico City',
  'גואטמלה סיטי': 'Guatemala City',
  'בלמופן': 'Belmopan',
  'סן סלבדור': 'San Salvador',
  'טגוסיגלפה': 'Tegucigalpa',
  'מנגואה': 'Managua',
  'פנמה סיטי': 'Panama City',
  'הוואנה': 'Havana',
  'קינגסטון': 'Kingston',
  'פורט-או-פרנס': 'Port-au-Prince',
  'סנטו דומינגו': 'Santo Domingo',
  'סן חואן': 'San Juan',
  'פורט אוף ספיין': 'Port of Spain',
  'ברידג\'טאון': 'Bridgetown',
  'נסאו': 'Nassau',
  'בוגוטה': 'Bogota',
  'קראקס': 'Caracas',
  'ג\'ורג\'טאון': 'Georgetown',
  'פרמריבו': 'Paramaribo',
  'קאיין': 'Cayenne',
  'ברזיליה': 'Brasilia',
  'סאו פאולו': 'Sao Paulo',
  'ריו דה ז\'ניירו': 'Rio de Janeiro',
  'קיטו': 'Quito',
  'גואיאקיל': 'Guayaquil',
  'לימה': 'Lima',
  'לה פאס': 'La Paz',
  'סוקרה': 'Sucre',
  'אסונסיון': 'Asuncion',
  'מונטווידאו': 'Montevideo',
  'בואנוס איירס': 'Buenos Aires',
  'סנטיאגו': 'Santiago',
  // Additional major cities with major airports
  'שארג\'ה': 'Sharjah',
  'בצרה': 'Basra',
  'ארביל': 'Erbil',
  'משהד': 'Mashhad',
  'איספהאן': 'Isfahan',
  'שיראז': 'Shiraz',
  'קראצ\'י': 'Karachi',
  'לאהור': 'Lahore',
  'קוואטה': 'Quetta',
  'פשאוור': 'Peshawar',
  'צ\'יטאגונג': 'Chittagong',
  'קאנדי': 'Kandy',
  'גאלה': 'Galle',
  'פוקרה': 'Pokhara',
  'מנדליי': 'Mandalay',
  'לואנג פראבאנג': 'Luang Prabang',
  'סיאם ריפ': 'Siem Reap',
  'דה נאנג': 'Da Nang',
  'הווי': 'Hue',
  'נהא טראנג': 'Nha Trang',
  'ג\'והור באהרו': 'Johor Bahru',
  'קוטה קינבאלו': 'Kota Kinabalu',
  'סוראביה': 'Surabaya',
  'בנדונג': 'Bandung',
  'בל': 'Bali',
  'דנפאסר': 'Denpasar',
  'יוגיאקרטה': 'Yogyakarta',
  'מדאן': 'Medan',
  'מקאסר': 'Makassar',
  'סבאו': 'Cebu',
  'דאבו': 'Davao',
  'קאושיונג': 'Kaohsiung',
  'טאיצונג': 'Taichung',
  'ג\'ג\'ו': 'Jeju',
  'נארה': 'Nara',
  'קנזאווה': 'Kanazawa',
  'קונמינג': 'Kunming',
  'שיאמן': 'Xiamen',
  'סיה': 'Sanya',
  'הארבין': 'Harbin',
  'אורומצ\'י': 'Urumqi',
  'להאסה': 'Lhasa',
  'האט יאי': 'Hat Yai',
  'קו סמוי': 'Ko Samui',
  'קו פאנגאן': 'Ko Pha Ngan',
  'קו טאו': 'Ko Tao',
  'קו ליפה': 'Ko Lipe',
  'קו צ\'אנג': 'Ko Chang',
  'איהוטאיה': 'Ayutthaya',
  'סוקותאי': 'Sukhothai',
  'קנצ\'נבורי': 'Kanchanaburi',
  'פיטסנולוק': 'Phitsanulok',
  'צ\'יאנג ראי': 'Chiang Rai',
  'מאה סונג': 'Mae Hong Son',
  'נאנ': 'Nan',
  'לומפאנג': 'Lampang',
  'סוראט תאני': 'Surat Thani',
  'טראנג': 'Trang',
  'סאטון': 'Satun',
  'סונגקלה': 'Songkhla',
  'נאקון סי תאמאראט': 'Nakhon Si Thammarat',
  'הואהין': 'Hua Hin',
  'צ\'אום': 'Cha-am',
  'ראיונג': 'Rayong',
  'צ\'ון בורי': 'Chonburi',
  'סראט': 'Saraburi',
  'לופבורי': 'Lopburi',
  'נאקון ראצ\'אסימה': 'Nakhon Ratchasima',
  'קוראט': 'Khorat',
  'אודון תאני': 'Udon Thani',
  'קון קן': 'Khon Kaen',
  'נאקון פאנום': 'Nakhon Phanom',
  'מוקדהאן': 'Mukdahan',
  'סוואנאקת': 'Savannakhet',
  'פאקסה': 'Pakse',
  'וואנג ויאנג': 'Vang Vieng',
  'סיהאנוקוויל': 'Sihanoukville',
  'באטמבאנג': 'Battambang',
  'קמפונג צ\'אם': 'Kampong Cham',
  'דא לאט': 'Da Lat',
  'הוי אן': 'Hoi An',
  'מוי נה': 'Mui Ne',
  'פו קווק': 'Phu Quoc',
  'הא לונג': 'Ha Long',
  'סאפה': 'Sapa',
  'ניה טראנג': 'Nha Trang',
  // Israeli cities and towns
  'מעלות תרשיחא': 'Ma\'alot-Tarshiha',
  'מעלות': 'Ma\'alot',
  'תרשיחא': 'Tarshiha',
  'נהריה': 'Nahariya',
  'עכו': 'Acre',
  'צפת': 'Safed',
  'טבריה': 'Tiberias',
  'כרמיאל': 'Karmiel',
  'נצרת': 'Nazareth',
  'עפולה': 'Afula',
  'בית שאן': 'Beit She\'an',
  'יקנעם': 'Yokneam',
  'מגדל העמק': 'Migdal HaEmek',
  'ערד': 'Arad',
  'דימונה': 'Dimona',
  'ירוחם': 'Yeruham',
  'מצפה רמון': 'Mitzpe Ramon',
  // Countries
  'איחוד האמירויות': 'United Arab Emirates',
  'איחוד האמירויות הערביות': 'United Arab Emirates',
  'האמירויות': 'United Arab Emirates',
  'ארצות הברית': 'United States',
  'ארה"ב': 'United States',
  'בריטניה': 'United Kingdom',
  'אנגליה': 'England',
  'ספרד': 'Spain',
  'איטליה': 'Italy',
  'צרפת': 'France',
  'גרמניה': 'Germany',
  'הולנד': 'Netherlands',
  'בלגיה': 'Belgium',
  'שוויץ': 'Switzerland',
  'אוסטריה': 'Austria',
  'פורטוגל': 'Portugal',
  'שוודיה': 'Sweden',
  'נורווגיה': 'Norway',
  'דנמרק': 'Denmark',
  'פינלנד': 'Finland',
  'פולין': 'Poland',
  'צ\'כיה': 'Czech Republic',
  'הונגריה': 'Hungary',
  'רומניה': 'Romania',
  'בולגריה': 'Bulgaria',
  'קרואטיה': 'Croatia',
  'סלובניה': 'Slovenia',
  'סלובקיה': 'Slovakia',
  'אירלנד': 'Ireland',
  'איסלנד': 'Iceland',
  'מלטה': 'Malta',
  'רוסיה': 'Russia',
  'אוקראינה': 'Ukraine',
  'בלארוס': 'Belarus',
  'ליטא': 'Lithuania',
  'לטביה': 'Latvia',
  'אסטוניה': 'Estonia',
  'גאורגיה': 'Georgia',
  'ארמניה': 'Armenia',
  'אזרבייג\'ן': 'Azerbaijan',
  'קזחסטן': 'Kazakhstan',
  'אוזבקיסטן': 'Uzbekistan',
  'טורקמניסטן': 'Turkmenistan',
  'קירגיזסטן': 'Kyrgyzstan',
  'טג\'יקיסטן': 'Tajikistan',
  'אפגניסטן': 'Afghanistan',
  'פקיסטן': 'Pakistan',
  'הודו': 'India',
  'בנגלדש': 'Bangladesh',
  'סרי לנקה': 'Sri Lanka',
  'נפאל': 'Nepal',
  'בהוטן': 'Bhutan',
  'מיאנמר': 'Myanmar',
  'לאוס': 'Laos',
  'קמבודיה': 'Cambodia',
  'וייטנאם': 'Vietnam',
  'מלזיה': 'Malaysia',
  'אינדונזיה': 'Indonesia',
  'ברוניי': 'Brunei',
  'הפיליפינים': 'Philippines',
  'טאיוואן': 'Taiwan',
  'מונגוליה': 'Mongolia',
  'קוריאה הצפונית': 'North Korea',
  'קוריאה הדרומית': 'South Korea',
  'יפן': 'Japan',
  'איראן': 'Iran',
  'עיראק': 'Iraq',
  'סוריה': 'Syria',
  'לבנון': 'Lebanon',
  'ירדן': 'Jordan',
  'ישראל': 'Israel',
  'פלסטין': 'Palestine',
  'ערב הסעודית': 'Saudi Arabia',
  'כווית': 'Kuwait',
  'בחריין': 'Bahrain',
  'קטר': 'Qatar',
  'עומאן': 'Oman',
  'תימן': 'Yemen',
  'סודאן': 'Sudan',
  'דרום סודאן': 'South Sudan',
  'אתיופיה': 'Ethiopia',
  'אריתריאה': 'Eritrea',
  'ג\'יבוטי': 'Djibouti',
  'סומליה': 'Somalia',
  'קניה': 'Kenya',
  'טנזניה': 'Tanzania',
  'אוגנדה': 'Uganda',
  'רואנדה': 'Rwanda',
  'בורונדי': 'Burundi',
  'מוזמביק': 'Mozambique',
  'מדגסקר': 'Madagascar',
  'מאוריציוס': 'Mauritius',
  'סיישל': 'Seychelles',
  'קומורו': 'Comoros',
  'מאוריטניה': 'Mauritania',
  'מאלי': 'Mali',
  'בורקינה פאסו': 'Burkina Faso',
  'ניז\'ר': 'Niger',
  'צ\'אד': 'Chad',
  'קמרון': 'Cameroon',
  'גבון': 'Gabon',
  'קונגו': 'Congo',
  'הרפובליקה הדמוקרטית של קונגו': 'Democratic Republic of the Congo',
  'הרפובליקה המרכז אפריקאית': 'Central African Republic',
  'גינאה המשוונית': 'Equatorial Guinea',
  'סאו טומה ופרינסיפה': 'Sao Tome and Principe',
  'גינאה': 'Guinea',
  'גינאה ביסאו': 'Guinea-Bissau',
  'גמביה': 'Gambia',
  'סנגל': 'Senegal',
  'אלג\'יריה': 'Algeria',
  'לוב': 'Libya',
  'תוניסיה': 'Tunisia',
  'אוסטרליה': 'Australia',
  'ניו זילנד': 'New Zealand',
  'פיג\'י': 'Fiji',
  'פפואה ניו גינאה': 'Papua New Guinea',
  'איי שלמה': 'Solomon Islands',
  'ונואטו': 'Vanuatu',
  'קלדוניה החדשה': 'New Caledonia',
  'פולינזיה הצרפתית': 'French Polynesia',
  'סמואה': 'Samoa',
  'טונגה': 'Tonga',
  'קיריבטי': 'Kiribati',
  'טובאלו': 'Tuvalu',
  'נאורו': 'Nauru',
  'פלאו': 'Palau',
  'מיקרונזיה': 'Micronesia',
  'איי מרשל': 'Marshall Islands',
  'קנדה': 'Canada',
  'מקסיקו': 'Mexico',
  'גואטמלה': 'Guatemala',
  'בליז': 'Belize',
  'אל סלבדור': 'El Salvador',
  'הונדורס': 'Honduras',
  'ניקרגואה': 'Nicaragua',
  'קוסטה ריקה': 'Costa Rica',
  'פנמה': 'Panama',
  'קובה': 'Cuba',
  'ג\'מייקה': 'Jamaica',
  'האיטי': 'Haiti',
  'הרפובליקה הדומיניקנית': 'Dominican Republic',
  'פוארטו ריקו': 'Puerto Rico',
  'טרינידד וטובגו': 'Trinidad and Tobago',
  'ברבדוס': 'Barbados',
  'בהאמה': 'Bahamas',
  'קולומביה': 'Colombia',
  'ונצואלה': 'Venezuela',
  'גיאנה': 'Guyana',
  'סורינאם': 'Suriname',
  'גיאנה הצרפתית': 'French Guiana',
  'ברזיל': 'Brazil',
  'אקוודור': 'Ecuador',
  'פרו': 'Peru',
  'בוליביה': 'Bolivia',
  'פרגוואי': 'Paraguay',
  'אורוגוואי': 'Uruguay',
  'ארגנטינה': 'Argentina',
  'צ\'ילה': 'Chile',
};

// Basic Hebrew to English transliteration mapping
const hebrewToLatin = {
  'א': 'a', 'ב': 'b', 'ג': 'g', 'ד': 'd', 'ה': 'h',
  'ו': 'v', 'ז': 'z', 'ח': 'ch', 'ט': 't', 'י': 'y',
  'כ': 'k', 'ך': 'k', 'ל': 'l', 'מ': 'm', 'ם': 'm',
  'נ': 'n', 'ן': 'n', 'ס': 's', 'ע': 'a', 'פ': 'p',
  'ף': 'f', 'צ': 'ts', 'ץ': 'ts', 'ק': 'k', 'ר': 'r',
  'ש': 'sh', 'ת': 't',
  // Vowels
  'ָ': 'a', 'ַ': 'a', 'ֶ': 'e', 'ֵ': 'e', 'ִ': 'i',
  'ֹ': 'o', 'ֻ': 'u', 'ְ': '', 'ֲ': 'a', 'ֱ': 'e',
  'ֳ': 'o', 'ׁ': '', 'ׂ': '',
};

/**
 * Transliterate Hebrew text to English
 * @param {string} text - Hebrew text to transliterate
 * @returns {string} - Transliterated text in English
 */
export const transliterateHebrew = (text) => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  // Remove extra spaces and trim
  const trimmed = text.trim();
  
  // First check if it's a known place name
  const normalized = trimmed.replace(/\s+/g, ' '); // Normalize spaces
  if (commonPlacesMapping[normalized]) {
    return commonPlacesMapping[normalized];
  }

  // Try case-insensitive match
  const lowerText = normalized.toLowerCase();
  for (const [hebrew, english] of Object.entries(commonPlacesMapping)) {
    if (hebrew.toLowerCase() === lowerText) {
      return english;
    }
  }

  // Try to handle city + country combinations (e.g., "בנגקוק תאילנד")
  // Split by space and try to find each part
  const words = normalized.split(/\s+/).filter(w => w.length > 0);
  if (words.length >= 2) {
    // Try to find city and country separately
    const cityPart = words.slice(0, -1).join(' '); // All words except last
    const countryPart = words[words.length - 1]; // Last word
    
    const cityEnglish = commonPlacesMapping[cityPart] || commonPlacesMapping[cityPart.toLowerCase()];
    const countryEnglish = commonPlacesMapping[countryPart] || commonPlacesMapping[countryPart.toLowerCase()];
    
    if (cityEnglish && countryEnglish) {
      return `${cityEnglish} ${countryEnglish}`;
    }
    
    // Also try the reverse - maybe the first word is country
    const countryPartFirst = words[0];
    const cityPartRest = words.slice(1).join(' ');
    
    const countryEnglishFirst = commonPlacesMapping[countryPartFirst] || commonPlacesMapping[countryPartFirst.toLowerCase()];
    const cityEnglishRest = commonPlacesMapping[cityPartRest] || commonPlacesMapping[cityPartRest.toLowerCase()];
    
    if (cityEnglishRest && countryEnglishFirst) {
      return `${cityEnglishRest} ${countryEnglishFirst}`;
    }
    
    // If we found at least the city, return it
    if (cityEnglish) {
      return cityEnglish;
    }
  }

  // If not found in mapping, do character-by-character transliteration
  let result = '';
  for (let i = 0; i < trimmed.length; i++) {
    const char = trimmed[i];
    
    // Skip spaces, keep them
    if (char === ' ' || char === '-') {
      result += char;
      continue;
    }
    
    // Check if it's a Hebrew character
    if (char >= '\u0590' && char <= '\u05FF') {
      // Hebrew character - transliterate
      if (hebrewToLatin[char]) {
        result += hebrewToLatin[char];
      } else {
        // Unknown Hebrew character, skip it
        result += '';
      }
    } else {
      // Non-Hebrew character (English, numbers, etc.) - keep as is
      result += char;
    }
  }

  // Clean up result: remove multiple spaces, capitalize first letter of each word
  return result
    .replace(/\s+/g, ' ')
    .trim()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Check if text contains Hebrew characters
 * @param {string} text - Text to check
 * @returns {boolean} - True if text contains Hebrew characters
 */
export const containsHebrew = (text) => {
  if (!text || typeof text !== 'string') {
    return false;
  }
  
  // Hebrew Unicode range: \u0590-\u05FF
  const hebrewRegex = /[\u0590-\u05FF]/;
  return hebrewRegex.test(text);
};

/**
 * Smart transliteration - converts Hebrew to English if needed
 * @param {string} text - Text that might be in Hebrew
 * @returns {string} - English text (transliterated if needed)
 */
export const smartTransliterate = (text) => {
  if (!text || typeof text !== 'string') {
    return '';
  }

  // If text contains Hebrew, transliterate it
  if (containsHebrew(text)) {
    return transliterateHebrew(text);
  }

  // Otherwise return as is
  return text;
};

/**
 * Add common place names to the mapping
 * @param {Object} mapping - Object with Hebrew keys and English values
 */
export const addPlaceMapping = (mapping) => {
  Object.assign(commonPlacesMapping, mapping);
};

/**
 * Get all known place mappings
 * @returns {Object} - Copy of the place mappings
 */
export const getPlaceMappings = () => {
  return { ...commonPlacesMapping };
};
